export const dictionary = {
  CREATE_TITLE: {
    ES: "Crear producto",
    EN: "Create product",
  },
  UPDATE_TITLE: {
    ES: "Actualizar producto",
    EN: "Update product",
  },
  TITLE: {
    ES: "Tus productos",
    EN: "Your products",
  },
  PRODUCT_TITLE: {
    ES: "Título",
    EN: "Title",
  },
  PRICE: {
    ES: "Precio",
    EN: "Price",
  },
  PRICE_PROMOTIONAL: {
    ES: "Precio promocional (opcional)",
    EN: "Promotional price (optional)",
  },
  FEATURED: {
    ES: "Destacar producto",
    EN: "Featured product",
  },
  DESCRIPTION: {
    ES: "Descripción (opcional)",
    EN: "Description (optional)",
  },
  SKU: {
    ES: "SKU (opcional)",
    EN: "SKU (optional)",
  },
  STATUS: {
    ES: "Estado",
    EN: "Status",
  },
  AVAILABLE: {
    ES: "Disponible",
    EN: "Available",
  },
  NOT_AVAILABLE: {
    ES: "No disponible",
    EN: "Not available",
  },
  HIDDEN: {
    ES: "Oculto",
    EN: "Hidden",
  },
  CATEGORIES: {
    ES: "Categorías",
    EN: "Categories",
  },
  PRODUCT_VARIANTS: {
    ES: "Variantes",
    EN: "Variants",
  },
  ADD_VARIANTS: {
    ES: "Agregar variantes +",
    EN: "Add variants +",
  },
  CREATE_VARIANT_TITLE: {
    ES: "Crear variante",
    EN: "Create variant",
  },

  UPDATE_VARIANT_TITLE: {
    ES: "Actualizar variante",
    EN: "Update variant",
  },
  VARIANT_TITLE: {
    ES: "Título de la variante",
    EN: "Variant title",
  },
  VARIANT_REQUIRED: {
    ES: "¿El cliente debe elegir una opción?",
    EN: "This variant is required?",
  },
  VARIANT_OPTIONS: {
    ES: "Opciones",
    EN: "Options",
  },
  ADD_OPTION: {
    ES: "Agregar nueva opción",
    EN: "Add a new option",
  },
  MESSAGGE: {
    ES: "El precio de la variante se le sumará al precio del producto.",
    EN: "The price of the variant will be added to the price of the product.",
  },
  OPTION_TITLE: {
    ES: "Título",
    EN: "Title",
  },
  PRODUCT_IMAGES: {
    ES: "Imágenes",
    EN: "Images",
  },
  MAX_IMAGES: {
    ES: "Sube hasta 4 imágenes",
    EN: "Upload up to 4 images",
  },
  VIEW_PRODUCT: {
    ES: "Ver producto",
    EN: "View product",
  },
  NO_CATEGORY: {
    ES: "Sin categoría",
    EN: "No category",
  },
  REMOVE_CONFIRM: {
    ES: "¿Estás seguro que deseas eliminar este producto? \n No podrás recuperarlo.",
    EN: "Are you sure you want to delete this product? \n  You won't be able to recover it.",
  },
  EMPTY_LIST: {
    ES: "Aún no tienes productos",
    EN : "No products yet"
  }
} as const;
